/** App-level campaign name limits (must match backend `_CAMPAIGN_NAME_*`). */
export const CAMPAIGN_NAME_MIN_LEN = 3;
export const CAMPAIGN_NAME_MAX_LEN = 50;

/**
 * Render a campaign name so consecutive spaces stay visible.
 * HTML/CSS (and `-webkit-line-clamp`) collapse U+0020; NBSP does not.
 */
export function displayCampaignName(raw) {
  return String(raw ?? "").replace(/ /g, "\u00A0");
}

/**
 * Validate a campaign name after trim.
 * @returns {{ ok: true, name: string } | { ok: false, error: string }}
 */
export function validateCampaignName(raw) {
  const name = String(raw ?? "").trim();
  if (!name) {
    return { ok: false, error: "Campaign name is required" };
  }
  if (name.length < CAMPAIGN_NAME_MIN_LEN) {
    return {
      ok: false,
      error: `Campaign name must be at least ${CAMPAIGN_NAME_MIN_LEN} characters`,
    };
  }
  if (name.length > CAMPAIGN_NAME_MAX_LEN) {
    return {
      ok: false,
      error: `Campaign name must be at most ${CAMPAIGN_NAME_MAX_LEN} characters`,
    };
  }
  return { ok: true, name };
}
